export default __webpack_public_path__ + "static/media/jenkins-svgrepo-com.4387b8df.svg";